import { SubtitlesUploaderComponent } from './components/subtitles-list/components/subtitles-uploader/subtitles-uploader.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { DataTestModule } from '@app/shared/directive/data-test';
import { FormsDropdownACModule } from '@app/shared/forms/dropdown-ac/dropdown-ac.module';
import { AccesibilityModule } from '@app/shared/accesibility/accesibility.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadSubtitlesListComponent } from './components/subtitles-list/subtitles-list.component';
import { UploadSubtitlesLanguageComponent } from './components/subtitles-list/components/subtitles-language/subtitles-language.component';
import { UploadSubtitlesItemComponent } from './components/subtitles-list/components/subtitles-item/subtitles-item.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ReactiveFormsModule } from '@angular/forms';
import { PipeModule, LoaderModule } from '@app/shared';

@NgModule({
    declarations: [UploadSubtitlesListComponent, UploadSubtitlesLanguageComponent, UploadSubtitlesItemComponent, SubtitlesUploaderComponent],
    imports: [
        CommonModule,
        TranslateModule,
        AccesibilityModule,
        FormsDropdownACModule,
        DataTestModule,
        ReactiveFormsModule,
        InlineSVGModule,
        NgxFileDropModule,
        PipeModule,
        LoaderModule,
    ],
    exports: [UploadSubtitlesListComponent],
})
export class SubtitlesUploaderModule {}
